import React from 'react';
export const ArrowRight = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4243_34945)">
      <mask
        id="mask0_4243_34945"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="18"
      >
        <rect width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4243_34945)">
        <path
          d="M7.05 13.5L6 12.45L9.45 9L6 5.55L7.05 4.5L11.55 9L7.05 13.5Z"
          fill="#C4964D"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4243_34945">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
